import { formatDate } from '@angular/common';
import {
  AfterViewInit,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
declare let L: any;
@Component({
  selector: 'gtapp-leaflet-trail-map',
  standalone: false,
  templateUrl: './leaflet-trail-map.component.html',
  styleUrl: './leaflet-trail-map.component.scss',
})
export class LeafletTrailMapComponent implements OnChanges, AfterViewInit {
  @Input() routeData: any = [];
  @Input() zoomInEvent: any;
  @Input() mapId: string = 'mapId';
  mapData: any;

  routeLayer = L.layerGroup();
  decoratorLayer = L.layerGroup();
  animationLayer = L.layerGroup();
  markerLayer = L.layerGroup();

  routeCoords: any = [];

  initialFitDone = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['routeData']?.previousValue !==
        changes['routeData']?.currentValue &&
      this.mapData
    ) {
      const routeCords = this.routeData
        ?.filter((coord: any) => coord?.gps?.lat && coord?.gps?.lon)
        ?.map((item: any) => [item?.gps?.lat, item?.gps?.lon]);

      this.routeCoords = routeCords?.reverse();

      this.drawAll();
    }
    if (
      changes['zoomInEvent']?.previousValue !==
        changes['zoomInEvent']?.currentValue &&
      this.zoomInEvent?.gps?.lat &&
      this.zoomInEvent?.gps?.lon &&
      this.mapData
    ) {
      this.mapData?.stop();
      this.mapData.setView(
        [this.zoomInEvent?.gps?.lat, this.zoomInEvent?.gps?.lon],
        12,
        {
          animate: true,
          pan: {
            duration: 1.0,
          },
        },
      );
      // this.mapData.flyTo({
      //   center: [this.zoomInEvent?.gps?.lat, this.zoomInEvent?.gps?.lon],
      //   zoom: 12, // higher zoom will freeze the screens with animation
      //   speed: 0.8,
      //   curve: 1.2,
      //   essential: true,
      //   duration: 0.5,
      // });
    }
  }
  ngAfterViewInit(): void {
    const routeCords = this.routeData
      ?.filter((coord: any) => coord?.gps?.lat && coord?.gps?.lon)
      ?.map((item: any) => [item?.gps?.lat, item?.gps?.lon]);
    this.routeCoords = routeCords?.reverse();

    this.initMap();
    this.routeLayer.addTo(this.mapData);
    this.decoratorLayer.addTo(this.mapData);
    this.animationLayer.addTo(this.mapData);
    this.markerLayer.addTo(this.mapData);
    if (this.routeCoords?.length) {
      this.drawAll();
    }
  }
  drawAll() {
    this.clearLayers();
    this.addWaypointMarkers();
    this.addRouteArrows();
    this.addStaticMarker();
    // this.animateCar();
  }
  clearLayers() {
    this.routeLayer?.clearLayers();
    this.decoratorLayer?.clearLayers();
    this.animationLayer?.clearLayers();
    this.markerLayer?.clearLayers();
  }

  initMap() {
    var container: any = L.DomUtil.get(this.mapId);
    if (container != null) {
      container._leaflet_id = null;
    }

    const mapConfig = {
      preferCanvas: true,
      layers: [
        L.tileLayer('https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
          maxZoom: 18,
          minZoom: 2,
          subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
        }),
      ],

      closePopupOnClick: false,
      zoomSnap: false,
      zoomDelta: false,
      trackResize: false,
    };
    this.mapData = L.map(this.mapId, mapConfig);
    const markerCluster = new L.MarkerClusterGroup();
    this.mapData.addLayer(markerCluster);

    let embeddedLinkElement: any = document.querySelectorAll(
      '.leaflet-control-attribution.leaflet-control',
    );
    if (embeddedLinkElement) {
      embeddedLinkElement.forEach((element: any) => {
        element.classList.add('d-none');
      });
    }
  }
  getUserPin() {
    const svgIcon = `
<svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle r="4" cx="12" cy="12" fill="#4285f4" stroke="#d3e0f6" stroke-width="3"/>
    </svg>
  `;

    return L.divIcon({
      className: 'custom-pin',
      iconSize: [60, 60], // Increased size of the icon
      iconAnchor: [30, 30], // Center the icon at the bottom
      popupAnchor: [30, -30], // Adjust the popup position
      html: svgIcon,
    });
  }
  getMarkerPin(color = 'rgb(255, 127, 0)') {
    const svgIcon = `
    <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2C8.13 2 5 5.13 5 9C5 13.25 10.25 20 11.08 21.08C11.37 21.44 11.68 21.74 12 22C12.32 21.74 12.63 21.44 12.92 21.08C13.75 20 19 13.25 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9C9.5 7.62 10.62 6.5 12 6.5C13.38 6.5 14.5 7.62 14.5 9C14.5 10.38 13.38 11.5 12 11.5Z" fill="${color}"/>
    </svg>
  `;
    return L.divIcon({
      className: 'custom-pin',
      iconSize: [60, 60], // Increased size of the icon
      iconAnchor: [30, 60], // Center the icon at the bottom
      popupAnchor: [0, -60], // Adjust the popup position
      html: svgIcon,
    });
  }

  addStaticMarker() {
    let lastCoords = this.routeCoords[this.routeCoords?.length - 1];
    const marker = L.marker(lastCoords, {
      icon: this.getUserPin(),
    });
    // .bindTooltip('Last Known Location', {
    //   permanent: true,
    //   direction: 'top',
    // });

    this.markerLayer.addLayer(marker);
    this.mapData.setView(lastCoords, 12, {
      animate: true,
      pan: {
        duration: 1.0,
      },
    });
  }

  addRouteArrows() {
    const polyline = L.polyline(this.routeCoords);

    let decoratorLine = L.polylineDecorator(polyline, {
      patterns: [
        {
          offset: 0,
          repeat: 1,
          symbol: L.Symbol.dash({
            pixelSize: 2,
            pathOptions: {
              color: '#fff',
              stroke: true,
              weight: 2, // thickess of line
            },
          }),
        },
        // {
        //   offset: 0,
        //   repeat: 1,
        //   symbol: L.Symbol.dash({
        //     pixelSize: 2,
        //     pathOptions: {
        //       color: '#0080d9',
        //       stroke: true,
        //       weight: 2, // thickness of line
        //     },
        //   }),
        // },
      ],
    });

    const decorator = L.polylineDecorator(polyline, {
      patterns: [
        {
          offset: 0,
          repeat: 20, // gap between chevrons
          symbol: (L as any).Symbol.arrowHead({
            pixelSize: 10, // width of chevron
            polygon: false,
            pathOptions: {
              stroke: true,
              color: '#0080d9',
              weight: 2, // thickness of chevrons
            },
          }),
        },

        {
          offset: 7,
          repeat: 20, // gap between chevrons
          symbol: (L as any).Symbol.arrowHead({
            pixelSize: 10, // width of chevron
            polygon: false,
            pathOptions: {
              stroke: true,
              color: '#0080d9',
              weight: 2, // thickness of chevrons
            },
          }),
        },
      ],
    });
    this.decoratorLayer.addLayer(decoratorLine);
    this.decoratorLayer.addLayer(decorator);
    if (!this.initialFitDone) {
      this.mapData.fitBounds(polyline.getBounds());
      this.initialFitDone = true;
    }
  }

  // animateCar() {
  //   const carMovingIcon = L.icon({
  //     iconUrl: 'assets/images/qr-code-logo.avif',
  //     iconSize: [32, 32],
  //   });

  //   const animatedMarker = (L as any).animatedMarker(this.routeCoords, {
  //     icon: carMovingIcon,
  //     autoStart: true,
  //     distance: 100,
  //     interval: 200,
  //   });

  //   this.mapData.addLayer(animatedMarker);
  // }
  addWaypointMarkers() {
    const newMarkers: any = [];

    this.routeData.forEach((item: any, index: number) => {
      if (index !== 0 && item?.gps?.lat && item?.gps?.lon) {
        const marker = L.marker([item?.gps?.lat, item?.gps?.lon], {
          icon: this.getUserPin(),
        }).bindTooltip(
          `${formatDate(item?.updated_at, 'HH:mm:ss', 'en_US')}`,

          {
            permanent: true,
            direction: 'bottom',
          },
        );
        newMarkers.push(marker);
      }
    });

    newMarkers.forEach((m: any) => this.markerLayer.addLayer(m));
  }
}
